<template>
  <div class="vd-gl-content">
    <a-row class="vd-toolbar">
      <a-form-model>
        <a-form-model-item label="内容">
          <a-input v-model="form.content" type="textarea" />
        </a-form-model-item>
        <a-form-model-item label="附件">
          <a-upload
            accept="image/*"
            :multiple="true"
            :action="upload_url"
            @change="onChange"
            list-type="picture"
            :file-list="fileList"
          >
            <a-button>
              <a-icon type="upload" />
              上传图片
            </a-button>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14 }">
          <a-button type="primary" @click="submit">
            提交
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-row>
  </div>
</template>

<script>
import { idea } from '@/api'

export default {
  name: 'Index',
  data() {
    let upload_url = this.UPLOAD_URL

    return {
      upload_url,
      form: {
        content: '',
      },
      fileList: [],
    }
  },
  methods: {
    onChange(e) {
      let status = e.file.status
      if (status === 'uploading') {
        this.fileList = e.fileList
      } else if (status === 'done') {
        e.fileList.forEach((item) => {
          if (item.status === 'done') {
            if (item.response.code === 1) {
              item.thumbUrl = item.response.info.web_url
            }
          }
          return item
        })
        this.fileList = e.fileList
      } else if (status === 'error') {
        console.log('上传错误')
      } else if (status === 'removed') {
        this.fileList = e.fileList
      }
    },
    submit() {
      // 获取图片地址数组
      let pics = []
      this.fileList.forEach((item) => {
        pics.push(item.thumbUrl)
        return true
      })
      idea({
        content: this.form.content,
        picUrl: pics,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.msg)
          this.visible = false
          this.form.content = ''
          this.fileList = []
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
  },
}
</script>

<style scoped></style>
